import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import WaterView from './WaterView';
import ElectricityView from './ElectricityView.js';
import GasView from './NaturalGasView.js';
import GuideNav from './GuideNav.js';

export default class DisplayGuide extends Component {

  render(){
    return (
      <div id="main-content" className="container guide">
        <h1><span><img className="leaf-img" src="/img/leaf.png" alt="A cartoon leaf falling in the wind"></img></span>Sustainability Guide</h1>
        <GuideNav />
        <Switch>
            <Route exact path='/guide' render={ (renderProps) => 
                  (<WaterView {...renderProps} uiConfig={this.uiConfig}/>)}/>
            <Route path='/guide/electric' render={ (renderProps) => 
                  (<ElectricityView {...renderProps} uiConfig={this.uiConfig}/>)}/>
            <Route path='/guide/natural-gas' render={ (renderProps) => 
                  (<GasView {...renderProps} uiConfig={this.uiConfig}/>)}/>
        </Switch>

      </div>
    )
  }
}